import CloseRequestPayload from "slotworks/model/gameplay/requests/close-request-payload";
import CommsManager from "slotworks/server/comms-manager";
import { Services } from "slotworks/services/services";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";

export function CloseCommand(): Contract<void> {
    return new Parallel<void>([
        () => CommsManager.request(new CloseRequestPayload()),
        () => Services.autoplay.updateWinLoss()
    ]);
}
